import { Link } from "@tanstack/react-router";
import { StaticTooltipHost, tokens } from "@vintecc/components";

interface NavItemProps {
  tooltipLabel: string;
  to: string;
  params?: Record<string, string>;
  search?: Record<string, unknown>;
  color?: string | null;
  icon?: React.ReactNode;
  fallbackInitials: string;
  tooltipPlace?: "right" | "top";
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const NavItem = ({ tooltipLabel, to, params, search, color, icon, fallbackInitials, tooltipPlace = "right", onClick }: NavItemProps) => {
  return (
    <StaticTooltipHost
      tooltip={<span className="font-semibold">{tooltipLabel}</span>}
      customStyling={{ fill: "var(--background-navigation)", textColor: tokens.color.white[100] }}
      radixProps={{ contentProps: { sideOffset: 8 } }}
      place={tooltipPlace}
    >
      <Link
        to={to}
        params={params}
        search={search}
        className="text-xl h-12 w-12 flex items-center justify-center text-(--navigation-item-color) relative shrink-0 snap-start before:absolute before:inset-0 before:rounded-xl before:transition-colors before:-z-1"
        aria-label={tooltipLabel}
        style={{ ["--color" as string]: color ?? tokens.color.blue[300] }}
        onClick={(e) => {
          if (!onClick) return;
          e.preventDefault();
          onClick(e);
        }}
      >
        {icon ?? <span className="capitalize text-2xl">{fallbackInitials}</span>}
      </Link>
    </StaticTooltipHost>
  );
};
